import { useTheme } from "../../../theme/src";
import { TOAST_TYPE } from '../constants';
export const useIconStyle = ({ type }) => {
    const theme = useTheme();
    switch (type) {
        case TOAST_TYPE.ERROR:
            return {
                color: theme.colors.fire,
                iconName: 'circle-exclamation',
            };
        case TOAST_TYPE.SUCCESS:
            return {
                color: theme.colors.grass,
                iconName: 'circle-check',
            };
        case TOAST_TYPE.BLANK:
        default:
            return {
                color: theme.colors.primary,
                iconName: 'circle-info',
            };
    }
};
//# sourceMappingURL=getIconStyle.js.map